import CartSeed from './CartSeed';

export default CartSeed;
